"use client"

import { DatadogAppRouter } from "@datadog/browser-rum-nextjs"

// Renders the App Router view-tracking component required by nextjsPlugin().
// Must be mounted once in app/layout.tsx, inside <body>.
export const DatadogProvider = () => <DatadogAppRouter />
